<template>
  <app-page-container
    :showNav="true"
    :navBackgroundLight="true"
    footerColor="#fbfbfb"
    navBackgroundColor="#fbfbfb"
  >
    <div class="changelog">
      <div class="changelog-entries">
        <div class="changelog-entry">
          <div class="changelog-content">
            <div class="changelog-entry-title">About Cofocus</div>
            <div class="changelog-text">
              <img
                class="about-image"
                src="https://ik.imagekit.io/elysiumone/cofocus_together_z4Fx-5c4ie.png"
              />
              <p>
                Cofocus connects people from all over the world for virtual
                coworking sessions to help people be more productive.
              </p>
              <p>
                You can be a student studying for an exam, a teacher prepping
                for class, a writer writing your first novel, a coder trying to
                fix that pesky bug or just someone trying to learn a new skill
                or even get some reading done &mdash; if you&rsquo;re working on
                your own, you can benefit from Cofocus.
              </p>
              <p>
                The way Cofocus works is by scheduling sessions at times
                you&rsquo;d like to get some work done and then being matched
                with accountability partners. When a session starts, you and
                your partner join, greet each other, declare goals for the
                session and get to work. When a session ends, you exchange how
                your session went, perhaps chit-chat a little and then part
                ways.
              </p>
              <p>
                We believe every human has a tremendous amount of potential in
                them and that if more people were able to realize their
                potential without being stopped in their tracks by the endless
                distractions of the modern world, we&rsquo;d solve many of the
                world&rsquo;s problems and move towards a cooler and better
                world much faster.
              </p>
              <p>
                Cofocus got its start in December 2020. We weren&rsquo;t
                satisfied with the existing solutions out there for social
                productivity (or productivity in general) and felt much more
                could be done, and done in a much more delightful way. We wanted
                to create a solution that transcended utilitarian value and
                provided an experience that felt deeply personal.&nbsp;
              </p>
              <p>
                We&rsquo;re a small team of hardworking, passionate spartans
                that make no excuses. We care deeply about creating the best
                possible experience for people and we work nonstop to create
                ever-better solutions that help people get more done and make it
                easier to achieve their goals, realize their dreams and make the
                world better for it.
              </p>
              <p>Let&rsquo;s create a really cool world together!&nbsp;</p>
              <p class="post-h3">
                Our team wouldn&rsquo;t be the same if it weren&rsquo;t for our
                Chief Happiness Squad.
              </p>
              <div class="dogs">
                <div class="dog">
                  <img
                    class="dog-image"
                    src="https://ik.imagekit.io/elysiumone/yoko_FdVn-63vaT.jpeg"
                  />
                  <div class="dog-name">Yoko</div>
                </div>
                <div class="dog">
                  <img
                    class="dog-image"
                    src="https://ik.imagekit.io/elysiumone/kenji_kTcgWnCq6.jpeg"
                  />
                  <div class="dog-name">Kenji</div>
                </div>
                <div class="dog">
                  <img
                    class="dog-image"
                    src="https://ik.imagekit.io/elysiumone/savannah_Ia9NbcAmoe.jpeg"
                  />
                  <div class="dog-name">Savannah</div>
                </div>
              </div>
              <!-- <p class="post-h3">
                Our team also comes with a cactus family &mdash; Bobina, April
                and Mango.
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-page-container>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";

export default {
  name: "About",
  components: {
    AppPageContainer,
  },
  mounted() {
    window.mixpanel.track("Visit About Page");
  }
};
</script>

<style scoped>
.changelog {
  /* min-width: 720px;
  max-width: 960px; */
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 40px;
  margin-bottom: -140px;
  background-color: #fbfbfb;
}
.changelog-header {
  padding: 60px 0px 80px;
  margin-left: 180px;
}
.changelog-title {
  font-size: 48px;
  font-weight: 600;
}
.changelog-entry {
  display: flex;
  margin-bottom: 100px;
}
.changelog-entry-title {
  font-size: 48px;
  font-weight: 700;
  padding-bottom: 10px;
  text-align: center;
  margin-bottom: 35px;
}
.changelog-content {
  width: 820px;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px 0 #afafaf57;
  border-radius: 6px;
  padding: 60px;
  margin-bottom: 40px;
  background-color: white;
}
.changelog-meta {
  width: 160px;
  box-sizing: border-box;
  margin-right: 10px;
}
.changelog-version {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: inherit;
  padding: 4px 16px;
  border-radius: 6px;
  background-color: #e2ebff;
  color: #4d50d4;
  font-weight: 600;
}
.changelog-text {
  font-size: 18px;
  line-height: 28px;
}
.changelog-date {
  padding: 12px 0px;
  font-size: 17px;
}
.changelog-image {
  width: calc(860px - 220px);
  border-radius: 6px;
  margin: 14px 5px;
  box-shadow: 0px 1px 4px 0 #afafaf57;
}

.changelog .instruction {
  margin-top: 30px;
  margin-bottom: 10px;
}

.changelog-text p,
.changelog-text li {
  line-height: 32px;
  margin: 16px 10px;
  font-variant: normal;
  text-decoration: none;
  vertical-align: baseline;
  white-space: normal;
  font-size: 19px;
}
.changelog-text li {
  list-style-type: disc;
  margin-left: 30px;
}
.changelog-text a {
  color: #5559d5;
}
.post-image {
  width: 100%;
  margin: 0 auto;
  border-radius: 6px;
}
.post-image:hover {
  filter: brightness(0.8);
}
.post-h3 {
  font-weight: 700;
  font-size: 21px !important;
}
.changelog-meta-inner {
  display: none;
  margin-bottom: 40px;
}
.dogs {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.dog {
  width: 50%;
  text-align: center;
  margin: 0px 3px;
}
.dog-image {
  max-width: 245px;
  max-width: 98%;
  border-radius: 2px;
  border-radius: 6px;
}
.dog-name {
  width: 100%;
  padding: 10px;
  font-size: 20px;
}
.about-image {
  width: 100%;
  margin: 0 auto;
  border-radius: 6px;
}
@media screen and (max-width: 1000px) {
  .changelog-meta {
    display: none;
  }
  .changelog-meta-inner {
    display: block;
  }
  .changelog-content {
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 770px) {
  .changelog {
    min-width: unset;
  }
  .changelog-content {
    border-radius: 0px;
    width: 100%;
    padding: 60px 35px;
  }
  .changelog-header {
    margin-left: unset;
    text-align: center;
    padding-bottom: 50px;
  }
  .changelog-title {
    font-size: 36px;
  }
}
</style>